@if (visible) {
    <div>
        {{ 'form.registrationSuccessful' | translate: { username: form.emailAddress } }}
    </div>
}
